import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  const formatName = (str) => {
    return str
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const breadcrumbNameMap = {
    'ops': 'Operations',
    'gov': 'GOV Connect',
    'dsat': 'DSAT',
    'sla-credits': 'SLA Credits',
    'health-map': 'Health Map',
    'einvoicing': 'E-Invoicing',
  };

  if (pathnames.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center gap-2 text-sm mb-4" aria-label="Breadcrumb">
      <Link
        to="/"
        className="flex items-center gap-1 transition-colors hover:underline"
        style={{ color: 'var(--text-secondary)' }}
      >
        <Home size={16} />
        <span>Home</span>
      </Link>

      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const displayName = breadcrumbNameMap[name] || formatName(name);

        return (
          <React.Fragment key={routeTo}>
            <ChevronRight size={16} style={{ color: 'var(--text-tertiary)' }} />
            {isLast ? (
              <span style={{ color: 'var(--text-primary)' }} className="font-medium">
                {displayName}
              </span>
            ) : (
              <Link
                to={routeTo}
                className="transition-colors hover:underline"
                style={{ color: 'var(--text-secondary)' }}
              >
                {displayName}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;